import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";
import { CMSPath } from "../../../config/constant";
import { formatLocalTime, formatTime, toBool } from "../../JS/utility";
import moment from "moment";
import { scrollToTop } from "../../../JS/scrollToTop";
import ShowDeprecatedAddonPopup from "./ShowDeprecatedAddonPopup";



const SpaBookingUpdatePopUp = (props) => {

  const { t } = props

  useEffect(() => {

    scrollToTop()
  }, [])

  return (
    <>

      <section class="widgets spa-listing spa-details">
        <div class="widget-header">
          {props.currentWidgetObj.widgetHeaderImageUrl && (
            <div class="widget-header-img">
              <img
                src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`}
                alt={props.currentWidgetObj.displayName}
              />
            </div>
          )}
          <div class="widget-header-title">{t("spaBooking.booking_overview")}</div>
        </div>

        <div class="detail-body stay-body">
          <div class="stay-info">
            <div class="stay-arrival">
              <div class="heading">{t("spaBooking.date")}</div>
              <div class="body">
                <p>
                  {moment(new Date(props.updateReservationDetails.date)).format(props.dateFormat.toUpperCase())}



                </p>
              </div>
            </div>
            <div class="stay-arrival">
              <div class="heading">{t("spaBooking.time")}</div>
              <div class="body">
                <p>{formatLocalTime(
                  new Date(props.updateReservationDetails.date),
                  toBool(props.timeFormat)
                )}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="detail-body stay-body">
              <form>
                <div class="form-row spa-summary">
                  <p class="heading">{t("spaBooking.details")}</p>
                  <label>
                    <span class="list-name">{t("spaBooking.serviceName")}</span> <span>{props.updateReservationDetails.serviceName || props.updateReservationDetails.lines[0].serviceName || ''}</span>
                  </label>
                  <label>
                    <span class="list-name">{t("spaBooking.locationName")}{" "}</span>
                    <span>{props.updateReservationDetails.locationName || ''} </span>
                  </label>
                  <label className="spa-technician_name">
                    <span class="list-name">{t("spaBooking.therapist")}{" "}</span>
                    <span>
                      {props.updateReservationDetails.lines[0].technician.fullNameDisplayed || ''}
                    </span>
                  </label>



                  {props.updateReservationDetails.lines[0].technician.gender && ['M', 'F'].includes(props.updateReservationDetails.lines[0].technician.gender) &&
                    <label>
                      <span class="list-name"> {t("spaBooking.therapist_gender")}{" "}</span>
                      <span>
                        {props.updateReservationDetails.lines[0].technician.gender == 'F' ? "Female" : "Male"}
                      </span>
                    </label>
                  }


                  {/* {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0]
                    &&
                    <label>
                      <span class="list-name">{t("spaBooking.base_price")}{" "}</span>
                      <span>
                        {`${props.currencyCode} ${props.updateReservationDetails.lines[0].price}`}
                      </span>
                    </label>
                  } */}


                  {

                    <label>
                      <span class="list-name">{t("spaBooking.duration")}{" "}</span>
                      <span>
                        {`${props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].duration} ${"minutes"}`}
                      </span>
                    </label>


                  }

                {
                props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].technician 
                &&  <label>
                      <span class="list-name">{t("spaBooking.base_price")}{" "}</span>
                      <span>   {`${props.currencyCode} ${props.updateReservationDetails.lines[0].price 
                - (
                  props.updateReservationDetails.lines[0].technician.price
                  +
                  (props.updateReservationDetails.lines[0].addOn && Array.isArray(props.updateReservationDetails.lines[0].addOn) && props.updateReservationDetails.lines[0].addOn.length > 0 ? props.updateReservationDetails.lines[0].addOn.reduce((acc, curr) => { return acc + curr.price; }, 0) : 0)
                )}`}
                </span>
                </label>
                }
                  


                  {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].technician
                    &&
                    <label class="therapist-cost">
                      <span class="list-name"> {t("spaBooking.therapist_cost")}{" "}</span>
                      <span>
                        {`${props.currencyCode} ${props.updateReservationDetails.lines[0].technician.price}`}
                      </span>
                    </label>
                  }




                  {


                    <div class="form-row price-total enhancement-summary">
                      <label>
                        <span class="list-name">   {t("spaBooking.enhancements") + " [" +
                          (props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].addOn && Array.isArray(props.updateReservationDetails.lines[0].addOn) && props.updateReservationDetails.lines[0].addOn.length > 0
                            ?
                            props.updateReservationDetails.lines[0].addOn.reduce((acc, curr, index) => {

                              if (props.updateReservationDetails.lines[0].addOn.length - 1 != index) {
                                return acc + curr.serviceName + ", "
                              }
                              return acc + curr.serviceName;
                            }, "")
                            :
                            "No enhancement opted ")
                          +
                          "]"
                        }
                        </span>
                        <span>

                          {props.currencyCode}{" "}
                          {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0] && props.updateReservationDetails.lines[0].addOn && Array.isArray(props.updateReservationDetails.lines[0].addOn) && props.updateReservationDetails.lines[0].addOn.length > 0 ? props.updateReservationDetails.lines[0].addOn.reduce((acc, curr) => { return acc + curr.price; }, 0) : 0}
                        </span>
                      </label>
                    </div>



                  }


                  {/* inclusive of addon and technician and service price */}
                  {props.updateReservationDetails.lines && props.updateReservationDetails.lines[0]  
                    &&
                    <label>
                      <span class="list-name">
                        {t("spaBooking.total_cost")}{" "}</span>
                      <span>
                        {`${props.currencyCode} ${props.updateReservationDetails.lines[0].price }`}
                        <span class="spa-price-per-person update">{t("spaBooking.per_person")}</span>
                      </span>
                    </label>
                  }







                  {props.updateReservationDetails.customerNotes &&
                    <label>
                      <span class="list-name"> {t("spaBooking.guest_notes")}{" "}</span>
                      <span>
                        {props.updateReservationDetails.customerNotes}
                      </span>
                    </label>
                  }

                </div>



              </form>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="form-controls">
            <button onClick={async () => { await props.update() }}>
              {t("spaBooking.edit_reservation_button")}
            </button>
            <button onClick={props.back}>{t("spaBooking.back")}</button>
          </div>
        </div>
      </section>


      {props.showDeprecatedAddonWarning &&
        <ShowDeprecatedAddonPopup
          message={`Some of enhancements [${props.deprecatedAddonList.reduce((acc, curr, index) => {
            let s = curr.serviceName;
            if (props.deprecatedAddonList.length - 1 != index) s = s + ", ";
            return acc + s;

          }, "")}] of this reservation are no longer available. If you proceed with updation of this reservation, you can loose those enhancement(s).`}
          onCancel={() => { props.shouldProceedOnDeprecatedAddonsWarning(false) }}
          onClick={() => { props.shouldProceedOnDeprecatedAddonsWarning(true) }} />}



    </>
  )
}


const mapStateToProps = state => {
  return {
    installedAppVersion: state.store.installedAppVersion,
    installedAppBuildNo: state.store.installedAppBuildNo,
    currentHomePage: state.store2.currentHomePage,
    guestDetail: state.store.home.guestDetails,
    guestIsLoggedIn: state.store2.guestIsLoggedIn,
    currentWidgets: state.store.sideNavBar.currentWidget,
    currentWidgetObj: state.store.sideNavBar.currentWidget,
    timeFormat: state.store.home.clientConfig.extraConfigParam.TIME_FORMAT_MERIDIEM
    , dateFormat: state.store.home.clientConfig.extraConfigParam
      ? state.store.home.clientConfig.extraConfigParam.DATE_FORMAT
      : "",
    currencyCode: state.store.home.clientConfig.currencyDetails
      ? state.store.home.clientConfig.currencyDetails.code
      : "",
  }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(SpaBookingUpdatePopUp));